import GeneralTemplate from '../general'

Hidden = GeneralTemplate({
  InputHandler: ({ startPlugin }) ->
    <div>
      This is a hidden template.
    </div>
})

export default Hidden